import { styled } from "styled-components";

export const Root = styled.div`
  margin-top: 20px;
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
`;
